import cx from 'classnames'
import { DocumentPropertyValue, instanceOfDocumentValue } from 'api/clients/PropertyClient'
import { EmojiItem } from 'common/EmojiItem/EmojiItem'
import { ReactComponent as ArticleEmoji } from '../icons/article.svg'
import Styles from '../PropertyValue.module.scss'

interface Props {
  propertyValue: DocumentPropertyValue
  emojiClass?: string
  titleClass?: string
}

const Document = ({ propertyValue, emojiClass, titleClass }: Props) => {
  if (!instanceOfDocumentValue(propertyValue)) return <></>

  const { value } = propertyValue

  return (
    <EmojiItem className={Styles.emojiItem} emojiClassName={emojiClass} emoji={value.header_emoji || <ArticleEmoji />}>
      <span className={cx(Styles.documentTitle, titleClass)}>{value?.title}</span>
    </EmojiItem>
  )
}

export default Document
